const http = require('../lib/httpClient');
const { getChannelId, getCookie, getEcommId } = require('../lib/browserData');
const getZoneId = require('../lib/zoneData');
const getPoliticalId = require('../lib/politicalIdData');

const { COOKIES, SELLER_EXPERIENCE } = require('../constants');
const constants = require('../constants');
const getPoliticalIdWithLatLong = require('../lib/politicalIdDataWithLatLong');

const SessionNotFoundError = {
  code: 'GET_CART_ERROR_SESSION_NOT_FOUND',
  message: 'Session not found',
};
const GetCartError = {
  code: 'GET_CART_ERROR',
  message: 'Failed to get cart',
};

const endpointPattern = '/s/checkout/v1/carts?{query}&rebuildDependencies=false';

async function catalystGetCart(tenantId, catalystBaseUrl = '', additionalInfo = {}) {
  const sessionId = getCookie(COOKIES.SESSION.VALUE);

  if (!sessionId) {
    return { data: undefined, errors: [SessionNotFoundError] };
  }
  const ecommName = getEcommId(tenantId, additionalInfo);
  const isTottus = ecommName.split('-')[0] === constants.ECOMM_NAME_TOTTUS;
  const {
    politicalId: tottusPoliticalId,
    lat,
    long,
  } = isTottus ? await getPoliticalIdWithLatLong(ecommName, catalystBaseUrl) : {};
  const zoneId =
    getCookie(COOKIES.SELLER_EXPERIENCE) === SELLER_EXPERIENCE.MARKETPLACE
      ? ''
      : await getZoneId(tenantId, catalystBaseUrl);
  const politicalId = isTottus
    ? tottusPoliticalId
    : await getPoliticalId(tenantId, catalystBaseUrl);
  const latLong = isTottus && lat && long ? `&lat=${lat}&long=${long}` : '';
  const baseQuery =
    getCookie(COOKIES.SELLER_EXPERIENCE) === SELLER_EXPERIENCE.MARKETPLACE
      ? `politicalAreaId=${politicalId}${latLong}`
      : `zoneId=${zoneId}${latLong}`;

  const deliveryFlow = getCookie(COOKIES.DELIVERY_FLOW);

  const queryParams = deliveryFlow ? `${baseQuery}&deliveryFlow=${deliveryFlow}` : baseQuery;
  const endpoint = endpointPattern.replace('{query}', queryParams);
  const result = await http.get(`${catalystBaseUrl}${endpoint}`, {
    headers: {
      Authorization: sessionId,
      'x-channel-id': getChannelId(),
      'x-ecomm-name': ecommName,
    },
  });

  const { responseBody } = result || {};

  if (!responseBody) return { data: undefined, errors: [GetCartError] };
  const { data: { cart, cart: { cartId, totalProductsQuantityCount } = {} } = {}, errors } =
    responseBody;
  if ([cart, cartId, totalProductsQuantityCount].includes(undefined)) {
    return { data: undefined, errors: errors || [GetCartError] };
  }
  return { data: cart, errors: [] };
}

module.exports = catalystGetCart;
